import { createSlice } from '@reduxjs/toolkit';
import { fetchOverallRating } from '../RatingsAPI/ratingsApi';

const overallRatingSlice = createSlice({
    name: "overallRating",
    initialState: {
        data: {},
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handle fetchOverallRating cases
            .addCase(fetchOverallRating.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchOverallRating.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchOverallRating.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default overallRatingSlice.reducer;
